import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../../providers/shared.service";
import { FormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { TranslateService } from "@ngx-translate/core";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AddProductComponent } from "../new-v2-component/add-product/add-product.component";
import { AddProductFromInventoryComponent } from "../new-v2-component/add-product-from-inventory/add-product-from-inventory.component";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-entity-products",
  templateUrl: "./entity-products.component.html",
  styleUrls: ["./entity-products.component.scss"],
})
export class EntityProductsComponent implements OnInit, OnDestroy {
  isEntityFitness:any = sessionStorage.getItem('isEntityIndividual')!
  entityHashId: string = "";
  entityHashIdForSearch: string = "";
  // clickEventSubscription: Subscription
  public loader: boolean = false;
  productList: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number;
  public page: number = 1;
  searchString: FormControl = new FormControl("");
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "services.column_headers.service_name"
      ),
      columnProperty: "serviceName",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.description"
      ),
      columnProperty: "description",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.approx_time"
      ),
      columnProperty: "approxTime",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.home_price"
      ),
      columnProperty: "home_price",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.shop_price"
      ),
      columnProperty: "shop_price",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.home_discounted_rate"
      ),
      columnProperty: "home_discounted_price",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.shop_discounted_rate"
      ),
      columnProperty: "shop_discounted_price",
    },
    {
      columnName: this.translateService.instant(
        "services.column_headers.service_type"
      ),
      columnProperty: "service_type",
    },
  ];

  constructor(
    private router: Router,
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private loaderservice: LoaderServiceService,
    private translateService: TranslateService,
    private authService:AuthService,
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        const getServiceType = (
          home_status: number,
          shop_status: number,
          virtual_status: number
        ) => {
          const combination =
            (home_status << 2) | (shop_status << 1) | virtual_status;

          switch (combination) {
            case 0b000:
              return "None"; // No services available
            case 0b001:
              return "Virtual";
            case 0b010:
              return "Shop";
            case 0b011:
              return "Shop + Virtual";
            case 0b100:
              return "Home";
            case 0b101:
              return "Home + Virtual";
            case 0b110:
              return "Shop + Home";
            case 0b111:
              return "Shop + Home + Virtual";
            default:
              return "Unknown";
          }
        };
        this.productList = [];
        this.datalength = 0;
        if (resData.result) {
          console.log(resData);

          this.productList = [];
          resData.result.forEach((element: any) => {
            this.productList.push(element);
          });

          this.productList.forEach((element) => {
            if (element.home_status == 0) {
              element.home_price = "-";
            }
            if (element.shop_status == 0) {
              element.shop_price = "-";
            }
            if (element.virtual_status == 0) {
              element.virtual_price = "-";
            }
            if (
              element.shop_discounted_price == null ||
              element.shop_discounted_price == 0
            ) {
              element.shop_discounted_price = "-";
            }
            if (
              element.home_discounted_price == null ||
              element.home_discounted_price == 0
            ) {
              element.home_discounted_price = "-";
            }
            if (
              element.virtual_discounted_price == null ||
              element.virtual_discounted_price == 0
            ) {
              element.virtual_discounted_price = "-";
            }
            element.service_type = getServiceType(
              element.home_status,
              element.shop_status,
              element.virtual_status
            );
          });
          console.log(this.productList);
          // this.productList.forEach((item )=> {
          //   item.addressInfo = JSON.parse(item.addressInfo).address_line
          // })
          console.log(this.productList);
        }
        this.loader = false;
        this.loaderservice.showLoader = false;
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_PRODUCT_DATA_BY_KEYWORD
      ) {
        const getServiceType = (
          home_status: number,
          shop_status: number,
          virtual_status: number
        ) => {
          const combination =
            (home_status << 2) | (shop_status << 1) | virtual_status;

          switch (combination) {
            case 0b000:
              return "None"; // No services available
            case 0b001:
              return "Virtual";
            case 0b010:
              return "Shop";
            case 0b011:
              return "Shop + Virtual";
            case 0b100:
              return "Home";
            case 0b101:
              return "Home + Virtual";
            case 0b110:
              return "Shop + Home";
            case 0b111:
              return "Shop + Home + Virtual";
            default:
              return "Unknown";
          }
        };
        this.productList = [];
        this.datalength = 0;
        if (resData.result) {
          console.log(resData);

          this.productList = [];
          resData.result.forEach((element: any) => {
            this.productList.push(element);
          });

          this.productList.forEach((element) => {
            if (element.home_status == 0) {
              element.home_price = "-";
            }
            if (element.shop_status == 0) {
              element.shop_price = "-";
            }
            if (element.virtual_status == 0) {
              element.virtual_price = "-";
            }
            if (
              element.shop_discounted_price == null ||
              element.shop_discounted_price == 0
            ) {
              element.shop_discounted_price = "-";
            }
            if (
              element.home_discounted_price == null ||
              element.home_discounted_price == 0
            ) {
              element.home_discounted_price = "-";
            }
            if (
              element.virtual_discounted_price == null ||
              element.virtual_discounted_price == 0
            ) {
              element.virtual_discounted_price = "-";
            }
            element.service_type = getServiceType(
              element.home_status,
              element.shop_status,
              element.virtual_status
            );
          });
          console.log(this.productList);
          // this.productList.forEach((item )=> {
          //   item.addressInfo = JSON.parse(item.addressInfo).address_line
          // })
          console.log(this.productList);
        }
        this.loader = false;
        this.loaderservice.showLoader = false;
      } 
      else if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_PRODUCT
      ) {
        if (resData.result && resData.result != null) {
          this._apiService.getEntityProductList(
            this.entityHashIdForSearch,
            this.page.toString()
          );
        }
      }
      else if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_PRODUCT
      ) {
        if (resData.result && resData.result != null) {
          this._apiService.getEntityProductList(
            this.entityHashIdForSearch,
            this.page.toString()
          );
        }
      }
    });
    console.log(this.productList);
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = [
        "service_name",
        "description",
        "approx_time",
        "home_price",
        "shop_price",
        "home_discounted_rate",
        "shop_discounted_rate",
      ];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `services.column_headers.${data[index]}`
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner() 
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.enPubHash;
      this.entityHashIdForSearch = data.entityHash;
    });

    this._apiService.getEntityProductList(
      this.entityHashIdForSearch,
      this.page.toString()
    );
  }
  selectedValue: string = "0";
  changeChip(value: string) {
    this.selectedValue = value;
    // this.loader = true
    this.loaderservice.showLoader = true;
    if (value == "0") {
      this._apiService.getServices(
        this.entityHashId,
        this.selectedValue,
        this.page.toString()
      );
    } else if (value == "1") {
      this._apiService.getServices(
        this.entityHashId,
        this.selectedValue,
        this.page.toString()
      );
    }
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService() {

       const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Warning!",
        message:
          "The custom item you are adding here would not have any link with inventory. If you want to track usage and auto inventory update based on sale, add the item first in Inventory.",
        okbtn: "Proceed",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let dialogref = this._modelRef.open(AddProductComponent, {
          width: "700px",
          data: {
            title: "Add product",
            type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
            ref: this._modelRef,
          },
        });
        dialogref.afterClosed().subscribe((res) => {
          if (res) {
            this._apiService.getEntityProductList(
              this.entityHashIdForSearch,
              this.page.toString()
            );
          }
        });
      
      }
    })

  }

  onCreateProductFromInventory() {
    let dialogref = this._modelRef.open(AddProductFromInventoryComponent, {
      width: "1000px",
      data: {
        title: "Add product",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getEntityProductList(
          this.entityHashIdForSearch,
          this.page.toString()
        );
      }
    });
  }
  onEditProduct(rowvalue: any) {
    this.loaderservice.showLoader = true;
    let dialogref = this._modelRef.open(AddProductComponent, {
      width: "700px",
      data: {
        title: "Edit product",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getEntityProductList(
          this.entityHashIdForSearch,
          this.page.toString()
        );
      }
    });
  }
  onCreateNewServiceFromTemplate() {
    let dialogref = this._modelRef.open(AddServiceTemplateItemComponent, {
      width: "1000px",
      data: {
        title: "Add service From Template",
        ref: this._modelRef,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getServices(
          this.entityHashId,
          this.selectedValue,
          this.page.toString()
        );
      }
    });
  }

  deactivateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 7,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashIdForSearch);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  activateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashIdForSearch);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      // width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this product?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let metadata = {
          entity_hash: this.entityHashIdForSearch,
          product_hash: rowvalue.hash_id,
        };
        this.loaderservice.showLoader = true;
        this._apiService.deleteEntityProduct(metadata);
      }
    });

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue: any) {
    let dialogref = this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Edit service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this._apiService.getServices(
          this.entityHashId,
          this.selectedValue,
          this.page.toString()
        );
      }
    });
  }
  isOwner: boolean = false
  ngOnDestroy(): void {
   
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getServices(
      this.entityHashId,
      this.selectedValue,
      this.page.toString()
    );
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getProductDataByKeywod(
        this.entityHashIdForSearch,
        this.searchString.value,
        this.page
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;

        this._apiService.getEntityProductList(
          this.entityHashIdForSearch,
          this.page.toString()
        );
      }
    }
  }

  openvideo() {
    this._modelRef.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/i4WR4SOc3qw?si=XBc7l4JDhhSZJg5w",
        title: "How to add products to sell in LookzUp platform.",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  reset() {
    this.searchString.reset();
    this.page = 1;

    this._apiService.getEntityProductList(
      this.entityHashIdForSearch,
      this.page.toString()
    );
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }

  changeStatus(item:any,status:any){
    this.loaderservice.showLoader = true
 


    let metadata = {
      "hash_id": item.hash_id,
      "entity_hash": item.entity_hash,
      "product_name": item.product_name,
      "product_desc": item.product_desc,
      "manufacturer": item.manufacturer,
      "qty_info": item.qty_info,
      "shop_price": item.shop_price && item.shop_price != '-' ? item.shop_price : 0,
      "home_price": item.home_price && item.home_price != '-' ? item.home_price : 0,
      "virtual_price": item.virtual_price && item.virtual_price != '-' ? item.virtual_price : 0,
      "discount": item.discount,
      "discount_status": item.discount_status,
      "shop_discounted_price": item.shop_discounted_price && item.shop_discounted_price != '-' ? item.shop_discounted_price : 0,
      "home_discounted_price": item.home_discounted_price && item.home_discounted_price != '-' ? item.home_discounted_price : 0,
      "virtual_discounted_price": item.virtual_discounted_price && item.virtual_discounted_price != '-' ? item.virtual_discounted_price : 0,
      "home_status": item.home_status,
      "shop_status": item.shop_status,
      "virtual_status": item.virtual_status,
      "tax_collection_status": item.tax_collection_status,
      "hsn_code": item.product_hsn_code,
      "tax_slab_hash": item.tax_slab_hash,
      "status":status
  }

    Object.keys(metadata).forEach(key => {
      if ((metadata as any)[key] === null) {
        delete (metadata as any)[key];
      }
    });
    
    
    this._apiService.addEditEntityProduct(metadata)
  }
}
